import { Alert } from 'antd';
import moment from 'moment';
import { ErrorBoundary } from 'react-error-boundary';

function ErrorBoundaryFallback({ error, children }) {
    if (error?.name === 'ChunkLoadError') {
        window.location.reload();
        return <></>;
    }

    if (process.env.REACT_APP_PRODUCTION === 'true') {
        window.onerror = (message, source, lineno, colno, error) => {
            const errorInfo = {
                errorMessage: message,
                errorComponentName: children?.props?.['data-id'],
                errorPath: window.location.pathname,
                errorTime: moment(new Date()).format('DD MMM YYYY hh:mm:ss'),
                errorBrowser: window.navigator.userAgent,
                userToken: localStorage.getItem('access_token') // find the current user through BE
            };
        };

        return <></>;
    }

    return (
        <div className="px-6 py-4">
            <Alert
                message="Error"
                description={`An error occurred ${error?.message ? error?.message : ''}`}
                type="error"
                closable
            />
        </div>
    );
}

function ErrorWrapper({ children }) {
    return (
        <ErrorBoundary
            FallbackComponent={({ error }) => (
                <ErrorBoundaryFallback
                    error={error}
                    children={children}
                />
            )}>
            {children}
        </ErrorBoundary>
    );
}

export default ErrorWrapper;
